import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
  mainContainer: {
    // padding: '60px 0',
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    backgroundColor: "transparent",
    padding: theme.spacingRules.cardPaddingDesktop,
    justifyContent: "space-evenly",
    maxWidth: "100%",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacingRules.cardPaddingMobile,
      flexDirection: "column",
    },
    "& > *": {
      color: theme.palette.text.primary,
    },
  },
  imgContainer: {
    width: "100%",
    height: "100%",
    backgroundColor: theme.agentTheme.background.main /* fallback color */,
    borderRadius: "4px",
    overflow: "hidden",
    [theme.breakpoints.down("sm")]: {
      height: 160,
    },
  },

  imageProps: {
    objectFit: "cover",
    height: "inherit",
    width: "inherit",
    filter: "brightness(0.7)",
    borderRadius: "4px",
    transition: "transform 0.5s",
    WebkitTransition: "transform 0.5s",
    "&:hover": {
      transform: "scale(1.2)",
      WebkitTransform: "scale(1.2)",
    },
  },
  dateText: {
    alignSelf: "flex-end",
    fontSize: "0.7rem",
    position: "absolute",
    right: theme.spacing(3),
    bottom: 5,
    color: theme.agentTheme.card.main,
  },
  nameInitials: {
    backgroundColor: theme.agentTheme.text.light,
    height: 50,
    width: 50,
    display: "flex",
    borderRadius: "50%",
    alignItems: "center",
    justifyContent: "center",
  },
  nameInitialsText: {
    fontSize: "1.4rem",
    fontWeight: "bold",
    color: theme.agentTheme.text.main,
  },
  headerText: {
    margin: "0px 20px",
    fontWeight: "600",
    fontSize: "40px",
    color: theme.agentTheme.background.secondary_text,
    [theme.breakpoints.down("sm")]: {
      fontSize: "30px",
      // marginTop: '24px',
    },
  },
  carouselItemContainer: {
    height: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-evenly",
  },
  carouselStepperContainer: {
    display: "flex",
    justifyContent: "center",
  },
  secondaryText: {
    color: theme.agentTheme.text.main,
  },
  otherText: {
    color: theme.agentTheme.text.light,
    width: "60%",
    margin: "16px auto 0px auto",
    fontSize: "20px",
    fontWeight: "400 !important",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      fontSize: "16px",
      marginTop: "8px",
    },
  },

  bgVideoOverlayContainer: {
    position: "absolute",
    bottom: theme.spacing(2),
    left: theme.spacing(2),
    color: "white",
    display: "flex",
    mixBlendMode: "difference",
    flexDirection: "column",
    WebkitBackdropFilter: "blur(0px)", // ✅ fixed
    backdropFilter: "blur(0px)",
  },

  destinationGridContainer: {
    display: "grid",
    gridGap: theme.spacing(2),
    gridTemplateRows: "300px 300px",
    gridTemplateColumns: "33% 32% 33%",
    // maxWidth:"94%",
    margin: "auto",
    paddingLeft: 60,
    paddingTop: 40,
    paddingRight: 60,
    paddingBottom: "40px",
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
      padding: 0,
      maxWidth: "100%",
      gridGap: 0,
      margin: 0,
    },
    "& > div": {
      position: "relative",
    },
  },
  gridLayout4: {
    gridTemplateAreas:
      '"gridItem1 gridItem1 gridItem4" "gridItem2 gridItem3 gridItem4"',
    [theme.breakpoints.down("sm")]: {
      gridTemplateAreas:
        '"gridItem1" "gridItem2" "gridItem3" "gridItem4" !important',
      gridTemplateRows: "300px 300px 300px 300px !important",
    },
  },
  gridLayout3: {
    gridTemplateAreas:
      '"gridItem1 gridItem1 gridItem1" "gridItem2 gridItem2 gridItem3"',
    [theme.breakpoints.down("sm")]: {
      gridTemplateAreas: '"gridItem1" "gridItem2" "gridItem3" !important',
      gridTemplateRows: "300px 300px 300px !important",
    },
  },
  gridLayout2: {
    gridTemplateAreas:
      '"gridItem1 gridItem1 gridItem2" "gridItem1 gridItem1 gridItem2"',
    [theme.breakpoints.down("sm")]: {
      gridTemplateAreas: '"gridItem1" "gridItem2" !important',
      gridTemplateRows: "300px 300px !important",
    },
  },
  gridLayout1: {
    gridTemplateAreas:
      '"gridItem1 gridItem1 gridItem1" "gridItem1 gridItem1 gridItem1"',
    [theme.breakpoints.down("sm")]: {
      gridTemplateAreas: '"gridItem1" !important',
      gridTemplateRows: "300px !important",
    },
  },
  gridItem1: {
    gridArea: "gridItem1",
  },
  gridItem2: {
    gridArea: "gridItem2",
  },
  gridItem3: {
    gridArea: "gridItem3",
  },
  gridItem4: {
    gridArea: "gridItem4",
  },
  bannerTextBtn: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.agentTheme.secondary.foreground,
    fontSize: "1rem",
    marginTop: theme.spacing(5),
    textTransform: "capitalize",
    borderRadius: "2px",
    "&:hover": {
      backgroundColor: theme.palette.secondary.main,
      color: theme.agentTheme.secondary.foreground,
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(1),
      width: "100%",
    },
  },
}));

export default useStyles;
